import React, { useState, memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { Icon } from "@iconify/react";
import styled from "styled-components";
import logo from "../../assets/img/logo_purple_arialblack120.png";

const SidebarWrap = styled.div`
  background-color: #ffffff;
  width: 240px;
  padding: 17px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoWrap = styled.div`
  margin-bottom: 40px;
  img {
    width: 140px;
  }
`;

const NavButton = styled(Button)`
  width: 90%;
  height: 48px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #9629fb;
  background-color: transparent;
  border: none;
  font-size: 16px;
  justify-content: flex-start;

  &:hover {
    background-color: #9629fb !important;
    color: #fff !important;
  }

  &.active {
    background-color: #9629fb !important;
    color: #fff !important;
  }

  .icon {
    margin-right: 16px;
    font-size: 22px;
  }
`;

const SubMenu = styled.div`
  width: 90%;
  padding-left: 24px;
  display: flex;
  flex-direction: column;

  .sub-item {
    background-color: transparent;
    border: none;
    color: #7c8695;
    font-size: 14px;
    margin: 4px 0;
    justify-content: flex-start;
    padding-left: 2.2rem;

    &.active {
      background-color: rgba(150, 41, 251, 0.1);
      color: #9629fb;
    }

    &:hover {
      color: #9629fb;
    }
  }
`;

const SidebarNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const current = location.pathname;

  const navItems = [
    {
      label: "Dashboard",
      path: "/landlord/dashboard/",
      icon: "material-symbols:analytics-outline-rounded",
    },
    {
      label: 'Property',
      path: '/landlord/property/setup',
      icon: 'material-symbols:home-app-logo',
      children: [
        {
          label: 'Property Setup',
          path: '/landlord/property/setup',
        },
        {
          label: "All Units",
          path: "/landlord/property/units",
        },
        {
          label: "Add Unit",
          path: "/landlord/property/unit",
        },
        {
          label: "Bank Details",
          path: "/landlord/property/banking",
        },
      ],
    },
    {
      label: "Applicants",
      path: "/landlord/applicants/",
      icon: "mdi:account-box-outline",
      children: [
        {
          label: "All Applicants",
          path: "/landlord/applicants",
        },
        // {
        //   label: "New",
        //   path: "/landlord/applicants/new",
        // },
        // {
        //   label: "Screened",
        //   path: "/landlord/applicants/screened",
        // },
        {
          label: "Application Setup",
          path: "/landlord/applicants/application",
        },
      ],
    },
    {
      label: "Lease",
      path: "/landlord/lease/",
      icon: "iconamoon:certificate-badge",
      children: [
        {
          label: "All",
          path: "/landlord/lease/",
        },
        {
          label: "Lease Term",
          path: "/landlord/lease/channel",
        },
        {
          label: "Rent, Deposit & Fees",
          path: "/landlord/lease/channel",
        },
        {
          label: "Options",
          path: "/landlord/lease/channel",
        },
        {
          label: "Clauses & Rules",
          path: "/landlord/lease/channel",
        },
        {
          label: "Disclosures",
          path: "/landlord/lease/channel",
        },
        {
          label: "Attachments",
          path: "/landlord/lease/channel",
        },
        {
          label: "Lessor Info",
          path: "/landlord/lease/channel",
        },
        {
          label: "Terms & Agreement",
          path: "/landlord/lease/channel",
        },
      ],
    },
    {
      label: "Maintenance",
      path: "/landlord/maintenance/",
      icon: "material-symbols:tools-wrench-outline",
    },
    {
      label: "Payments",
      path: "/landlord/payments/",
      icon: "humbleicons:currency-dollar-circle",
    },
    {
      label: "Chat",
      path: "/landlord/myposts/",
      icon: "mdi:chat-processing-outline",
    },
  ];

  const [openSubMenu, setOpenSubMenu] = useState(
    navItems.find((item) => item.children && current.startsWith(item.path))
      ?.label || null
  );

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <SidebarWrap>
      <LogoWrap>
        <img src={logo} alt="MOGUL Logo" />
      </LogoWrap>

      {navItems.map((item) => (
        <React.Fragment key={item.label}>
          <NavButton
            onClick={() => {
              if (item.children) {
                const isOpen = openSubMenu === item.label;
                const firstChildPath = item.children[0]?.path;

                if (!isOpen && firstChildPath) {
                  handleNavigate(firstChildPath);
                }

                setOpenSubMenu(isOpen ? null : item.label);
              } else {
                setOpenSubMenu(null);
                handleNavigate(item.path);
              }
            }}
            className={
              current === item.path ||
              (item.children &&
                item.children.some((child) => current.startsWith(child.path)))
                ? "active"
                : ""
            }
          >
            <Icon icon={item.icon} className="icon" />
            {item.label}
          </NavButton>

          {item.children && openSubMenu === item.label && (
            <SubMenu>
              {item.children.map((subItem) => (
                <Button
                  key={subItem.path}
                  type="text"
                  className={`sub-item ${
                    current === subItem.path ? "active" : ""
                  }`}
                  onClick={() => handleNavigate(subItem.path)}
                >
                  {subItem.label}
                </Button>
              ))}
            </SubMenu>
          )}
        </React.Fragment>
      ))}
    </SidebarWrap>
  );
};

const AuthLeftNav = memo(SidebarNav);
AuthLeftNav.displayName = "AuthLeftNav";

export default AuthLeftNav;
